module.exports = __webpack_public_path__ + "static/footimg-af5c03a7919c5b5c0e8677bb59d2e541.png";